
// Login
if(document.querySelector('#showpwd')){
    const showPwdBtn = document.querySelector('#showpwd');
    const showPwdField = document.querySelector('#fpwd');
    showPwdBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        console.log('showPwdBtn clic');
        if (showPwdField.type === "password") {
            showPwdField.type = "text";
        } else {
            showPwdField.type = "password";
        }
    });
}
